var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.products && _vm.products.length > 0)?_c('div',{attrs:{"id":"cart-recommendations"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('_cart.youMayAlsoLike')))]),_vm._v(" "),_c('CartRecommendationsList',{attrs:{"item-options":_vm.itemOptions,"products":_vm.products}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }